<template>
  <base-card body-class="pt-1">
    <template v-slot:body-top>
      <base-card-title class="mb-0" no-underline>Total Invested</base-card-title>
    </template>
    <div class="display-4 font-weight-bold mb-4">
      {{ totalInvested }}
    </div>
    <div v-if="ready && investments.length">
      <doughnut-chart
        v-model="invested"
        @colors="setColors"
      />
    </div>
    <template v-slot:bottom>
      <base-table :striped="false">
        <tbody>
          <tr v-for="(investment, key) in investments" :key="key">
            <td>
              <div style="height: 20px; width: 20px;" :style="{ backgroundColor: colors[investment._id] }"></div>
            </td>
            <td>{{ investment.investment.title }}</td>
            <td class="font-weight-semibold text-success">
              {{ $formatting.toCurrency(investment.invested) }}
            </td>
          </tr>
        </tbody>
      </base-table>
    </template>
  </base-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DoughnutChart from './DoughnutChart.vue'

export default {
  name: 'UserAccountInvested',

  components: {
    DoughnutChart
  },

  data: () => ({
    colors: {},
    invested: {},
    ready: false
  }),

  computed: {
    totalInvested () {
      return this.$formatting.toCurrency(
        this.$formatting.aggregateArrayAttribute(this.$auth.user.accounts, 'invested')
      )
    },

    ...mapState({
      investments: store => store.core.userInvestments.all,
      isAllPending: store => store.core.userInvestments.isAllPending
    })
  },

  async created () {
    await this.getInvestments()

    this.investments.forEach((investment) => {
      this.invested[investment._id] = investment.invested
    })

    this.ready = true
  },

  methods: {
    setColors (colors) {
      this.colors = colors
    },

    ...mapActions({
      getInvestments: 'core/user-investments/all'
    })
  }
}
</script>
